import type { Task } from '~/types/task.type'

export const useDragAndDropStore = defineStore('drag-and-drop', () => {
  const draggedTask = ref<Task<'withProject' | 'withTaskList'>>()

  const isDragging = ref(false)

  return {
    draggedTask,
    isDragging,
  }
})

if (import.meta.hot)
  import.meta.hot.accept(acceptHMRUpdate(useDragAndDropStore, import.meta.hot))
